export const getCdnUrl = (path: string) => `https://store.cdn.srprs.me/${path}`
